import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useEffect, useState } from 'react';

var ZestyFetchError = /*#__PURE__*/function (_Error) {
  _inherits(ZestyFetchError, _Error);

  var _super = _createSuper(ZestyFetchError);

  function ZestyFetchError(statusMessage) {
    var _this;

    _classCallCheck(this, ZestyFetchError);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "statusMessage", void 0);

    _this.statusMessage = statusMessage;
    return _this;
  }

  return ZestyFetchError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var useZesty = function useZesty(baseUrl, articleId) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  useEffect(function () {
    setLoading(true);

    var fetchData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var zestyUrl, response, _error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                zestyUrl = "".concat(baseUrl, "-/custom/article.json?uuid=").concat(articleId);
                _context.next = 4;
                return fetch(zestyUrl);

              case 4:
                response = _context.sent;

                if (!(response.status >= 200 && response.status < 300)) {
                  _context.next = 15;
                  break;
                }

                _context.t0 = setData;
                _context.next = 9;
                return response.json();

              case 9:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                setLoading(false);
                setError(null);
                _context.next = 17;
                break;

              case 15:
                _error = new ZestyFetchError(response.statusText);
                throw _error;

              case 17:
                _context.next = 23;
                break;

              case 19:
                _context.prev = 19;
                _context.t2 = _context["catch"](0);

                if (_context.t2 instanceof ZestyFetchError) {
                  setError(_context.t2);
                } else {
                  setError(new ZestyFetchError(JSON.stringify(_context.t2)));
                }

                setLoading(false);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 19]]);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, [baseUrl, articleId]);
  return {
    data: data,
    error: error,
    loading: loading
  };
};

export { useZesty };